import React, { useState, useEffect, useRef } from 'react';
import * as d3 from 'd3';
import PropTypes from 'prop-types';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var useResizeObserver = function useResizeObserver(ref) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      dimensions = _useState2[0],
      setDimensions = _useState2[1];

  useEffect(function () {
    var observeTarget = ref.current;
    var resizeObserver = new ResizeObserver(function (entries) {
      setDimensions(entries[0].contentRect);
    });
    resizeObserver.observe(observeTarget);
    return function () {
      return resizeObserver.unobserve(observeTarget);
    };
  }, [ref]);
  return dimensions;
};

var Shape$1 = /*#__PURE__*/function () {
  function Shape(coord, centerX, centerY) {
    _classCallCheck(this, Shape);

    this.coord = coord;
    this.centerX = centerX;
    this.centerY = centerY;
  }

  _createClass(Shape, null, [{
    key: "createSvgIcon",
    value: function createSvgIcon(x, y, shape, scale) {
      var result = "m ".concat(x - shape.centerX * scale, " ").concat(y - shape.centerY * scale, " ");

      for (var i = 0; i < shape.coord.length; i++) {
        if (shape.coord[i].type === 'line') result += "l ".concat(shape.coord[i].x * scale, " ").concat(shape.coord[i].y * scale);else if (shape.coord[i].type === 'move') {
          result += "m ".concat(shape.coord[i].x, " ").concat(shape.coord[i].y);
        } else if (shape.coord[i].type === 'arc') {
          result += "a ".concat(shape.coord[i].rx * scale, " ").concat(shape.coord[i].ry * scale, " ").concat(shape.coord[i].xAxisRotation, " ").concat(shape.coord[i].largeArc, " ").concat(shape.coord[i].otherSide, " ").concat(shape.coord[i].x * scale, " ").concat(shape.coord[i].y * scale);
        } else if (shape.coord[i].type === 'close') {
          result += 'z';
        } else if (shape.coord[i].type === 'curve') {
          result += "c ".concat(shape.coord[i].firstContolPointX, " ").concat(shape.coord[i].firstContolPointY, " ").concat(shape.coord[i].secondContolPointX, " ").concat(shape.coord[i].secondContolPointY, " ").concat(shape.coord[i].x, " ").concat(shape.coord[i].y);
        } else if (shape.coord[i].type === 'horizontal') {
          result += "h ".concat(shape.coord[i].length);
        } else if (shape.coord[i].type === 'vertical') {
          result += "v ".concat(shape.coord[i].length);
        }
        if (i < shape.coord.length) result += ' ';
      }

      return result;
    }
  }]);

  return Shape;
}();
var circle = new Shape$1([// a 1 1 0 0 1 0 10
{
  type: 'arc',
  rx: 1,
  ry: 1,
  xAxisRotation: 0,
  largeArc: 0,
  otherSide: 1,
  x: 0,
  y: 10
}, // a 1 1 0 0 1 0 -10
{
  type: 'arc',
  rx: 1,
  ry: 1,
  xAxisRotation: 0,
  largeArc: 0,
  otherSide: 1,
  x: 0,
  y: -10
}, {
  type: 'close'
}], 0, 5);
var triangle = new Shape$1([{
  type: 'line',
  x: 6,
  y: 10
}, {
  type: 'line',
  x: -12,
  y: 0
}, {
  type: 'close'
}], 0, 6);
var upsideDownTriangle$1 = new Shape$1([{
  type: 'line',
  x: 10,
  y: 0
}, {
  type: 'line',
  x: -5,
  y: 7.5
}, {
  type: 'close'
}], 5, 3);
var rhombus = new Shape$1([{
  type: 'line',
  x: 5,
  y: 5
}, {
  type: 'line',
  x: -5,
  y: 5
}, {
  type: 'line',
  x: -5,
  y: -5
}, {
  type: 'close'
}], 0, 5);
var square = new Shape$1([{
  type: 'line',
  x: 10,
  y: 0
}, {
  type: 'line',
  x: 0,
  y: 10
}, {
  type: 'line',
  x: -10,
  y: 0
}, {
  type: 'close'
}], 5, 5);
var hexagone = new Shape$1([{
  type: 'line',
  x: 5,
  y: 0
}, {
  type: 'line',
  x: 3,
  y: 5
}, {
  type: 'line',
  x: -3,
  y: 5
}, {
  type: 'line',
  x: -5,
  y: 0
}, {
  type: 'line',
  x: -3,
  y: -5
}, {
  type: 'line',
  x: 3,
  y: -5
}], 2.5, 5);
var octagon = new Shape$1([{
  type: 'line',
  x: 5,
  y: 0
}, {
  type: 'line',
  x: 3,
  y: 5
}, {
  type: 'line',
  x: -3,
  y: 5
}, {
  type: 'line',
  x: -5,
  y: 0
}, {
  type: 'line',
  x: -3,
  y: -5
}, {
  type: 'close'
}], 2.5, 5);
var bubble = function bubble(width) {
  return new Shape$1([// m 10 10
  // l 40 0
  {
    type: 'line',
    x: width,
    y: 0
  }, // a -1 1 0 0 1 0 10
  {
    type: 'arc',
    rx: -1,
    ry: -1,
    xAxisRotation: 0,
    largeArc: 0,
    otherSide: 1,
    x: 0,
    y: 15
  }, // l -40 0
  {
    type: 'line',
    x: -width,
    y: 0
  }, // a 1 1 0 0 1 0 -10
  {
    type: 'arc',
    rx: 1,
    ry: 1,
    xAxisRotation: 0,
    largeArc: 0,
    otherSide: 1,
    x: 0,
    y: -15
  }], -7.5, 7.5);
};
var bubbleUp = function bubbleUp(width) {
  return new Shape$1([{
    type: 'line',
    x: 0,
    y: -7.5
  }, {
    type: 'arc',
    rx: 10,
    ry: 10,
    xAxisRotation: 0,
    largeArc: 0,
    otherSide: 1,
    x: 10,
    y: -7.5
  }, {
    type: 'line',
    x: width,
    y: 0
  }, {
    type: 'arc',
    rx: 10,
    ry: 10,
    xAxisRotation: 0,
    largeArc: 0,
    otherSide: 1,
    x: 10,
    y: 7.5
  }, {
    type: 'line',
    x: 0,
    y: 7.5
  }, {
    type: 'close'
  }], 0, -7.5);
};
var bubbleDown = function bubbleDown(width) {
  return new Shape$1([{
    type: 'line',
    x: 0,
    y: 7.5
  }, {
    type: 'arc',
    rx: 10,
    ry: 10,
    xAxisRotation: 0,
    largeArc: 0,
    otherSide: 0,
    x: 10,
    y: 7.5
  }, {
    type: 'line',
    x: width,
    y: 0
  }, {
    type: 'arc',
    rx: 10,
    ry: 10,
    xAxisRotation: 0,
    largeArc: 0,
    otherSide: 0,
    x: 10,
    y: -7.5
  }, {
    type: 'line',
    x: 0,
    y: -7.5
  }, {
    type: 'close'
  }], 0, 7.5);
};
var bubbleMiddle = function bubbleMiddle(width) {
  return new Shape$1([// m 10 10
  // l 40 0
  {
    type: 'line',
    x: width + 20,
    y: 0
  }, {
    type: 'line',
    x: 0,
    y: 15
  }, {
    type: 'line',
    x: -width - 20,
    y: 0
  }, // a -1 1 0 0 1 0 10
  {
    type: 'close'
  }], 0, 7.5);
};
var nvBellIcon = 'M6.99992 16.3334C7.91658 16.3334 8.66658 15.5834 8.66658 14.6667H5.33325C5.33325 15.5834 6.07492 16.3334 6.99992 16.3334ZM11.9999 11.3334V7.16671C11.9999 4.60837 10.6332 2.46671 8.24992 1.90004V1.33337C8.24992 0.641707 7.69158 0.083374 6.99992 0.083374C6.30825 0.083374 5.74992 0.641707 5.74992 1.33337V1.90004C3.35825 2.46671 1.99992 4.60004 1.99992 7.16671V11.3334L0.333252 13V13.8334H13.6666V13L11.9999 11.3334Z';
var shapes = [circle, triangle, rhombus, square, hexagone, upsideDownTriangle$1, octagon];

var stockIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjQzcHgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQzIDQwIiB2ZXJzaW9uPSIxLjEiIGhlaWdodD0iNDBweCI+CiA8cGF0aCBkPSJtMTIuNSAwbC0xMi41IDguMSA4LjcgNyAxMi41LTcuOC04LjctNy4zem0tMTIuNSAyMS45bDEyLjUgOC4yIDguNy03LjMtMTIuNS03LjctOC43IDYuOHptMjEuMiAwLjlsOC44IDcuMyAxMi40LTguMS04LjYtNi45LTEyLjYgNy43em0yMS4yLTE0LjdsLTEyLjQtOC4xLTguOCA3LjMgMTIuNiA3LjggOC42LTd6bS0yMS4xIDE2LjNsLTguOCA3LjMtMy43LTIuNXYyLjhsMTIuNSA3LjUgMTIuNS03LjV2LTIuOGwtMy44IDIuNS04LjctNy4zeiIgZmlsbD0iIzAwN0VFNSIvPgo8L3N2Zz4K";
var pendingIcon = 'M18.32,4.26C16.84,3.05,15.01,2.25,13,2.05v2.02c1.46,0.18,2.79,0.76,3.9,1.62L18.32,4.26z M19.93,11h2.02 c-0.2-2.01-1-3.84-2.21-5.32L18.31,7.1C19.17,8.21,19.75,9.54,19.93,11z M18.31,16.9l1.43,1.43c1.21-1.48,2.01-3.32,2.21-5.32 h-2.02C19.75,14.46,19.17,15.79,18.31,16.9z M13,19.93v2.02c2.01-0.2,3.84-1,5.32-2.21l-1.43-1.43 C15.79,19.17,14.46,19.75,13,19.93z M15.59,10.59L13,13.17V7h-2v6.17l-2.59-2.59L7,12l5,5l5-5L15.59,10.59z M11,19.93v2.02 c-5.05-0.5-9-4.76-9-9.95s3.95-9.45,9-9.95v2.02C7.05,4.56,4,7.92,4,12S7.05,19.44,11,19.93z';
/**
 * format Y axis text
 */

function formatYTick(d) {
  var s = d.toFixed(1);
  return this.parentNode.nextSibling ? "\xA0".concat(s) : "".concat(s);
}
/**
 * format X axis text
 */

function formatXTick(d) {
  return getFormatedDate(new Date(d));
}
/**
 * Return from a date, a string with formatted date
 * @param {Date} date date to format month-day or Year-month-day
 * @param {boolean} withYear optionnal : if you want year in string
 * @return string
 */

var getFormatedDate = function getFormatedDate(date) {
  var withYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var day = String(date.getDate()).length === 1 ? "0".concat(date.getDate()) : date.getDate();
  var month = String(date.getMonth()).length === 1 ? "0".concat(date.getMonth() + 1) : date.getMonth() + 1;
  var year = date.getFullYear();
  return withYear ? "".concat(day, "/").concat(month, "/").concat(year) : "".concat(day, "/").concat(month);
};
/**
 * Return function used to create a Line
 * @param {Array<Number>} values Array of values used to generate line
 * @param {LinearScale} xScale d3 xScale
 * @param {LinearScale} yScale d3 yScale
 * @param {Number} xStart starting index of line (used if a point is mssing, and so they are multiple lines)
 * @return Function
 */


var myLine = function myLine(values, xScale, yScale) {
  var xStart = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var tempLine = d3.line().x(function (_value, index) {
    return xScale(index + xStart);
  }).y(function (value) {
    return yScale(value);
  }).curve(d3.curveMonotoneX);
  return tempLine(values);
};
/**
 * Generate on param svg selection, shapes
 * @param {Selection} svg d3 selection of svg dom element
 * @param {Object} dataset Object containing all necessary data
 * @param {Number} shapeIndex index used to identify which line worrepond to which shapes
 * @param {LinearScale} xScale d3 xScale
 * @param {LinearScale} yScale d3 yScale
 * @param {Number} hoverindex Index of point hovered by user mouse
 * @param {Function} handleHoverPoint Function called when a Point is hovered by user mouse
 * @param {Function} handleLeavePoint Function called when user leave hovered point
 * @param {Number} scale Scale of shapes (1 = no change)
 * @return void
 */


var generateShapes = function generateShapes(svg, dataset, shapeIndex, xScale, yScale, hoverIndex, handleHoverPoint, handleLeavePoint, scale, minValue) {

  dataset.display && svg.selectAll(".shape".concat(shapeIndex)).data(dataset.data).join("path").attr("class", "shape".concat(shapeIndex)).attr("index", function (value, index) {
    return index + 1;
  }).attr("transform", function (value, index) {
    return value === -1 || value === -101 ? value === -1 ? "translate(".concat(xScale(index + 1) - 6.5, ", ").concat(yScale(minValue) - 6.5, ")") : "translate(".concat(xScale(index + 1) - 10.5, ", ").concat(yScale(minValue) + 10, ")") : "translate(0, 0)";
  }).on("mouseenter", function (e) {
    var index = Number(e.target.getAttribute("index")) - 1;
    handleHoverPoint(index);
  }).on("mouseleave", function (event) {
    handleLeavePoint(event);
  }).transition().attr("d", function (value, index) {
    return value !== null && value !== -1 && value !== -101 ? Shape$1.createSvgIcon(xScale(index + 1), yScale(value), dataset.shape, index === hoverIndex ? scale + 0.8 : scale) : value === -1 ? nvBellIcon : value === -101 ? pendingIcon : "m 0 0";
  }).attr("fill-rule", "evenodd").attr("fill", function (value) {
    return value >= -1 || value === -101 ? dataset.color : "rgba(0,0,0,0)";
  }).duration(150);
  !dataset.display && svg.selectAll(".shape".concat(shapeIndex)).transition().attr("fill", "rgba(0,0,0,0)").duration(function (value, index) {
    return index * 15;
  }).remove();
};
/**
 * Generate on param svg selection, line
 * @param {Selection} svg d3 selection of svg dom element
 * @param {Object} dataset Object containing all necessary data
 * @param {Number} shapeIndex index used to identify which line worrepond to which shapes
 * @param {LinearScale} xScale d3 xScale
 * @param {LinearScale} yScale d3 yScale
 * @param {Number} strokeWidth line width
 * @return void
 */

var generateLine$1 = function generateLine(svg, dataset, shapeIndex, xScale, yScale, strokeWidth) {
  // Split dataset on null value
  var splitedDataset = splitArrayOnNull(dataset.data);
  splitedDataset.forEach(function (lineData, index) {
    dataset.display && svg.selectAll(".line".concat(shapeIndex).concat(index)).data([lineData.data]).join("path").attr("class", "line".concat(shapeIndex).concat(index)).attr("d", function (value) {
      return myLine(value, xScale, yScale, lineData.xStart + 1);
    }).attr("fill", "none").attr("stroke", dataset.color).transition().attr("stroke-width", strokeWidth).duration(150);
    !dataset.display && svg.selectAll(".line".concat(shapeIndex).concat(index)).transition().attr("stroke-width", 0).attr("stroke", "rgba(0,0,0,0)").duration(250).remove();
  });
};
/**
 * split array on null value, return array of array without null values
 * @param {Array<Number>} dataset Array to split
 * @return {Array<Array<Number>>}
 */

var splitArrayOnNull = function splitArrayOnNull(dataset) {
  var result = [];
  var temp = [];
  var xStart = null;
  dataset.forEach(function (value, index) {
    if (xStart === null) xStart = index;

    if (value <= 0 || value === null || value === undefined) {
      if (temp.length > 0) {
        result.push({
          data: temp,
          xStart: xStart
        });
      }

      temp = [];
      xStart = null;
    } else {
      temp.push(value);
    }
  });

  if (temp.length > 0) {
    result.push({
      data: temp,
      xStart: xStart
    });
  }

  return result;
};
/**
 * Generate and add to svg xAxis
 * @param {Selection} svg d3 selection of svg dom element
 * @param {Function} xAxis d3 Function used to generate xAxis
 * @param {{width: Number, height: Number}} dimensions svg dimensions
 * @return void
 */

var generateXAxis = function generateXAxis(svg, dimensions, xScaleTime, tickNumber) {

  var xAxis = d3.axisBottom(xScaleTime).ticks(tickNumber).tickSize(-dimensions.height + 20).tickFormat(formatXTick); // Add horizontal axis to svg

  svg.select(".x-axis").call(xAxis).call(function (g) {
    return g.select(".domain").remove();
  }) // Apply style to tick
  .call(function (g) {
    return g.selectAll(".tick line").attr("stroke-opacity", 1.5).style("color", "#A3A3A3");
  }).attr("transform", "translate(0, ".concat(dimensions.height - 20, ")")).style("color", "black");
};
var generateXAxisHover = function generateXAxisHover(svg, xAxis, dimensions, handleHoverPoint, handleLeavePoint, hoverIndex) {

  svg.select(".x-axis-hover").call(xAxis).call(function (g) {
    return g.select(".domain").remove();
  }).call(function (g) {
    return g.selectAll(".tick text").remove();
  }) // Apply style to tick
  .call(function (g) {
    return g.selectAll(".tick line").attr("class", "xAxisHover").attr("index", function (value, index) {
      return index;
    }).on("mouseenter", function (e) {
      var index = Number(e.target.getAttribute("index"));
      handleHoverPoint(index);
    }).on("mouseleave", function (event) {
      handleLeavePoint(event);
    }).transition().attr("stroke-width", function () {
      return 6;
    }).attr("color", function (value, index) {
      return index === hoverIndex ? "#237065" : "#23706400";
    }).duration(150);
  }) // Remove first tick
  .call(function (g) {
    return g.selectAll(".tick").filter(function (d) {
      return d === 0;
    }).remove();
  }).attr("transform", "translate(0, ".concat(dimensions.height - 20, ")"));
};
var generateYAxis = function generateYAxis(svg, yScale, dimensions, margin) {

  var yAxis = d3.axisLeft(yScale).ticks(5).tickSize(-dimensions.width + margin.left + margin.right).tickFormat(formatYTick); // Add vertical axis to svg

  svg.select(".y-axis").call(yAxis).call(function (g) {
    return g.select(".domain").remove();
  }).call(function (g) {
    return g.selectAll(".tick line").attr("stroke-opacity", 1.5).style("color", "#A3A3A3");
  }).attr("transform", "translate(".concat(margin.left, ", 0)")).style("color", "black");
};
var generateYAxisLabel = function generateYAxisLabel(svg, dimensions, x, y, currency) {
  // Add Price text
  svg.selectAll(".yAxisText").data([null]).join("text").attr("class", "yAxisText").attr("x", x).attr("y", y).attr("text-anchor", "middle").style("transform", "rotate(-0.25turn)").style("font-size", "20px").text("PRIX ".concat(currency));
};
var sortArrayOnData = function sortArrayOnData(toSort) {
  return toSort.sort(function (a, b) {
    return b.data - a.data;
  });
};
var generateRightPanel = function generateRightPanel(svg, data, xScale, yScale, xStart, handleBubbleClick, currency, dimensions, Facade, minValue) {
  var bubbleValue = []; // recreate data array with only last value in data field

  data.forEach(function (value) {
    var highestDataValue = Math.max.apply(Math, _toConsumableArray(value.data));

    if (highestDataValue > 0 || highestDataValue === -1 || highestDataValue === -101) {
      bubbleValue.push({
        data: value.data.slice(-1)[0],
        icon: value.icon,
        url: value.url,
        stock: value.stock.slice(-1)[0],
        name: value.name,
        color: value.color,
        shape: value.shape,
        display: value.display
      });
    }
  }); // Sort array on last value

  bubbleValue = sortArrayOnData(bubbleValue);
  var doesBubbleFit = bubbleValue.length * 60 < dimensions.height - 100;
  var lastBubbleY = 0;
  bubbleValue.forEach(function (oneData, lineToInfoIndex) {
    var bubbleX = xScale(xStart) + 50;
    var nextIncr = !!bubbleValue[lineToInfoIndex - 1] && bubbleValue[lineToInfoIndex - 1].data === bubbleValue[lineToInfoIndex].data ? doesBubbleFit ? 45 : 29 : doesBubbleFit ? 50 : 35;
    var isThereDataBefore = !!bubbleValue[lineToInfoIndex - 1];
    var isThereDataAfter = !!bubbleValue[lineToInfoIndex + 1];
    var isBeforeDataEqual = isThereDataBefore ? bubbleValue[lineToInfoIndex - 1].data === bubbleValue[lineToInfoIndex].data : false;
    var isAfterDataEqual = isThereDataAfter ? bubbleValue[lineToInfoIndex + 1].data === bubbleValue[lineToInfoIndex].data : false;
    var bubbleShape = null;

    if (isBeforeDataEqual && isAfterDataEqual) {
      bubbleShape = bubbleMiddle(doesBubbleFit ? 25 : 50);
    } else if (isBeforeDataEqual && !isAfterDataEqual) {
      bubbleShape = bubbleDown(doesBubbleFit ? 25 : 50);
    } else if (!isBeforeDataEqual && isAfterDataEqual) {
      bubbleShape = bubbleUp(doesBubbleFit ? 25 : 50);
    } else {
      bubbleShape = bubble(doesBubbleFit ? 30 : 55);
    }

    var bubbleY = lastBubbleY + nextIncr;
    lastBubbleY = bubbleY;
    var valid = oneData.data >= -2 || oneData.data === -101; // Add lines from graph to righ info bubbles

    oneData.display && valid && oneData.data !== 0 && oneData.data !== -2 && svg.selectAll(".line".concat(lineToInfoIndex)).data([oneData]).join("path").attr("class", "line".concat(lineToInfoIndex)).attr("d", function (value) {
      return "M".concat(xScale(xStart) + 15, ",").concat(yScale(oneData.data > -1 ? oneData.data : oneData.data === -101 ? minValue - 0.35 : minValue), ",").concat(bubbleX, ",").concat(bubbleY);
    }).attr("fill", "none").attr("stroke", function (value) {
      return oneData.display ? value.color : "grey";
    }).attr("stroke-width", 3);
    !oneData.display && svg.selectAll(".line".concat(lineToInfoIndex)).transition().attr("stroke", "rgba(0,0,0,0)").duration(250).remove(); // Add Shape on bubble start point

    valid && svg.selectAll(".bubbleShape".concat(lineToInfoIndex)).data([oneData]).join("path").attr("class", "bubbleShape".concat(lineToInfoIndex)).attr("d", function (value) {
      return Shape$1.createSvgIcon(bubbleX, bubbleY, value.shape, 1.4);
    }).attr("fill-rule", "evenodd").attr("fill", function (value) {
      if (value.data >= 0) {
        if (oneData.display) return value.color;
        return "grey";
      }

      return "rgba(0,0,0,0)";
    }); // Remove Shop Name

    svg.selectAll('[class^="bubbleShopName"]').remove(); // Add Image to bubble

    valid && svg.selectAll(".bubbleImage".concat(lineToInfoIndex)).data([oneData]).join("image").attr("class", "bubbleImage".concat(lineToInfoIndex)).attr("xlink:href", function (value) {
      return value.icon;
    }).attr("url", function (value) {
      return value.url;
    }).attr("height", "20").attr("width", "20").attr("x", bubbleX + 15).attr("y", bubbleY - 10); // Add price Text

    valid && oneData.data !== -1 && oneData.data !== -101 && svg.selectAll(".bubblePriceText".concat(lineToInfoIndex)).data([oneData]).join("text").attr("class", "bubblePriceText".concat(lineToInfoIndex)).attr("x", bubbleX + 40).attr("y", bubbleY + 5).attr("font-size", function (value) {
      return "".concat(18 - Facade.showDecimal(value.data, 2).length, "px");
    }).text(function (value) {
      return "".concat(Facade.showDecimal(value.data, 2)).concat(currency);
    }); // Add NVBELL If price === -1

    valid && oneData.data === -1 && svg.selectAll(".nvBellIcon".concat(lineToInfoIndex)).data([null]).join("path").attr("class", "nvBellIcon".concat(lineToInfoIndex)).attr("d", "M6.99992 16.3334C7.91658 16.3334 8.66658 15.5834 8.66658 14.6667H5.33325C5.33325 15.5834 6.07492 16.3334 6.99992 16.3334ZM11.9999 11.3334V7.16671C11.9999 4.60837 10.6332 2.46671 8.24992 1.90004V1.33337C8.24992 0.641707 7.69158 0.083374 6.99992 0.083374C6.30825 0.083374 5.74992 0.641707 5.74992 1.33337V1.90004C3.35825 2.46671 1.99992 4.60004 1.99992 7.16671V11.3334L0.333252 13V13.8334H13.6666V13L11.9999 11.3334Z").attr("fill", "#FACD19").attr("fill-opacity", "0.87").attr("transform", "translate(".concat(bubbleX + 60, " ").concat(bubbleY - 7, ")")); // Add pending If price === -101

    valid && oneData.data === -101 && svg.selectAll(".bubblePendingIcon".concat(lineToInfoIndex)).data([oneData]).join("image").attr("class", "bubbleImage".concat(lineToInfoIndex)).attr("xlink:href", 'https://img.pricecomparator.pro/graph_assets/pcp-logo.png').attr("height", "20").attr("width", "20").attr("x", bubbleX + 58).attr("y", bubbleY - 10); // Add stock icon to bubble

    valid && oneData.data > 0 && svg.selectAll(".bubbleStock".concat(lineToInfoIndex)).data([oneData]).join("image").attr("class", "bubbleStock".concat(lineToInfoIndex)).attr("class", function (value) {
      return "bubbleStock".concat(lineToInfoIndex);
    }).attr("style", function (value) {
      return "filter: ".concat(getFilterFromStock(value.stock));
    }).attr("xlink:href", stockIcon).attr("height", "20").attr("width", "20").attr("x", bubbleX + 95).attr("y", bubbleY - 10);
    svg.selectAll(".bubbleTitle".concat(lineToInfoIndex)).remove(); // Add bubbles to right info

    valid && svg.selectAll(".bubble".concat(lineToInfoIndex)).data([oneData]).join("path").attr("class", "bubble".concat(lineToInfoIndex)).attr("d", function () {
      return Shape$1.createSvgIcon(bubbleX, bubbleY, bubbleShape, doesBubbleFit ? 2.8 : 1.8);
    }).attr("fill", "#eeeeee00").attr("stroke", function (value) {
      return oneData.display ? value.color : "grey";
    }).attr("stroke-width", 3).style("cursor", "pointer").on("click", function (e, value) {
      handleBubbleClick(value);
    }).append("title").attr("class", "bubbleTitle".concat(lineToInfoIndex)).text("".concat(Facade.siteDisplayName(oneData.name), " : ").concat(oneData.data > 0 ? oneData.stock : oneData.data === -101 ? "Pending" : "Non vendu"));
  });
};
var generateRightPanelDownload = function generateRightPanelDownload(svg, data, xScale, yScale, xStart, handleBubbleClick, currency, dimensions, Facade) {
  var bubbleValue = []; // recreate data array with only last value in data field

  data.forEach(function (value) {
    var highestDataValue = Math.max.apply(Math, _toConsumableArray(value.data));

    if (highestDataValue > 0 || highestDataValue === -1) {
      bubbleValue.push({
        data: value.data.slice(-1)[0],
        icon: value.icon,
        url: value.url,
        stock: value.stock.slice(-1)[0],
        name: value.name,
        color: value.color,
        shape: value.shape,
        display: value.display
      });
    }
  }); // Sort array on last value

  var lastValue = sortArrayOnData(bubbleValue);
  var doesBubbleFit = lastValue.length * 60 < dimensions.height - 100;
  lastValue.forEach(function (oneData, lineToInfoIndex) {
    var bubbleX = xScale(xStart) + 50;
    var bubbleY = (lineToInfoIndex + 0.5) * (doesBubbleFit ? 50 : 35);
    var valid = oneData.data && oneData.data >= 0; // Add lines from graph to righ info bubbles

    oneData.display && valid && svg.selectAll(".line".concat(lineToInfoIndex)).data([oneData]).join("path").attr("class", "line".concat(lineToInfoIndex)).attr("d", function (value) {
      return "M".concat(xScale(xStart) + 15, ",").concat(yScale(value.data), ",").concat(bubbleX, ",").concat(bubbleY);
    }).attr("fill", "none").attr("stroke", function (value) {
      return oneData.display ? value.color : "grey";
    }).attr("stroke-width", 3);
    !oneData.display && svg.selectAll(".line".concat(lineToInfoIndex)).remove(); // Add Shape on bubble start point

    valid && svg.selectAll(".bubbleShape".concat(lineToInfoIndex)).data([oneData]).join("path").attr("class", "bubbleShape".concat(lineToInfoIndex)).attr("d", function (value) {
      return Shape$1.createSvgIcon(bubbleX, bubbleY, value.shape, 1.4);
    }).attr("fill-rule", "evenodd").attr("fill", function (value) {
      if (value.data >= 0) {
        if (oneData.display) return value.color;
        return "grey";
      }

      return "rgba(0,0,0,0)";
    }); // Remove Shop Icon

    svg.selectAll('[class^="bubbleImage"]').remove(); // Add Shop name

    svg.selectAll(".bubbleShopName".concat(lineToInfoIndex)).data([null]).join("text").attr("class", "bubbleShopName".concat(lineToInfoIndex)).attr("x", bubbleX + 15).attr("y", bubbleY - 5).text(Facade.siteDisplayName(oneData.name)); // Add price Text

    valid && svg.selectAll(".bubblePriceText".concat(lineToInfoIndex)).data([oneData]).join("text").attr("class", "bubblePriceText".concat(lineToInfoIndex)).attr("x", bubbleX + 40).attr("y", bubbleY + 10).attr("font-size", function (value) {
      return "".concat(16 - String(value.data).length, "px");
    }).text(function (value) {
      return "".concat(Facade.showDecimal(value.data, 2)).concat(currency);
    }); // Add stock icon to bubble

    valid && svg.selectAll(".bubbleStock".concat(lineToInfoIndex)).data([oneData]).join("image").attr("class", "bubbleStock".concat(lineToInfoIndex)).attr("class", function (value) {
      return "bubbleStock".concat(lineToInfoIndex);
    }).attr("style", function (value) {
      return "filter: ".concat(getFilterFromStock(value.stock.slice(-1)[0]));
    }).attr("xlink:href", stockIcon).attr("height", "20").attr("width", "20").attr("x", bubbleX + 130).attr("y", bubbleY - 10); // Remove bubbles to right info

    valid && svg.selectAll(".bubble".concat(lineToInfoIndex)).remove();
  });
};
var generateStockBackground = function generateStockBackground(svg, dimensions, xScale, maxIndex, handleStockWheel) {
  svg.selectAll(".stockBackground").data([dimensions]).join("rect").attr("class", "stockBackground").attr("x", function (_value, index) {
    return xScale(index) - 60;
  }).attr("y", dimensions.height - 120).attr("rx", 5).attr("ry", 5).attr("width", xScale(maxIndex) + 60).attr("height", 100).style("fill", "#EFEFEF").on("wheel", function (e) {
    handleStockWheel(e);
  }, {
    passive: true
  }); // Add stock text

  svg.selectAll(".stockText").data([null]).join("text").attr("class", "stockText").attr("x", -dimensions.height + 32).attr("y", xScale(0) - 40).style("transform", "rotate(-0.25turn)").style("font-size", "20px").text("STOCKS");
};
var generateStockBackgroundDownload = function generateStockBackgroundDownload(svg, dimensions, xScale, maxIndex, handleStockWheel) {
  svg.selectAll(".stockBackground").data([dimensions]).join("rect").attr("class", "stockBackground").attr("x", 5).attr("y", dimensions.height - 120).attr("rx", 5).attr("ry", 5).attr("width", dimensions.width - 10).attr("height", 100).style("fill", "#EFEFEF").on("wheel", function (e) {
    handleStockWheel(e);
  }, {
    passive: true
  }); // Add stock text

  svg.selectAll(".stockText").data([null]).join("text").attr("class", "stockText").attr("x", -dimensions.height + 40).attr("y", xScale(0) - 40).style("transform", "rotate(-0.25turn)").style("font-size", "20px").text("Stocks");
};
var generateStock = function generateStock(svg, dataset, stockIndex, dimensions, xScale, handleStockWheel, Facade) {
  // Add lines from graph to righ info bubbles
  svg.selectAll(".stockLine".concat(stockIndex)).data(dataset.stock.slice(0, -1)).join("path").attr("class", "stockLine".concat(stockIndex)).attr("d", function (value, index) {
    return "m ".concat(xScale(index + 1), " ").concat(dimensions.height - 100 + 17 * stockIndex, " l ").concat(xScale(index + 2) - xScale(index + 1), " 0");
  }).attr("fill", "none").attr("stroke", function (value) {
    if (value === "en stock") return "green";
    if (value === "sup. 48h") return "red";
    if (value === "rupture") return "black";
    return "grey";
  }).attr("stroke-width", 5).on("wheel", function (e) {
    handleStockWheel(e);
  }, {
    passive: true
  }); // Remove Title

  svg.selectAll(".stockIconTitle".concat(stockIndex)).remove(); // Add stock icon

  dataset.data > 0 && svg.selectAll(".stockIcon".concat(stockIndex)).data([dataset.stock.slice(-1)[0]]).join("image").attr("class", function (value) {
    return "stockIcon".concat(stockIndex);
  }).attr("style", function (value) {
    return "filter: ".concat(getFilterFromStock(value));
  }).attr("xlink:href", stockIcon).attr("height", "15").attr("width", "15").attr("x", xScale(dataset.stock.length) + 10).attr("y", dimensions.height - 108 + 17 * stockIndex).append("title").attr("class", "stockIconTitle".concat(stockIndex)).text("".concat(Facade.siteDisplayName(dataset.stock.slice(-1)[0]))); // Remove Shop Text

  svg.selectAll('[class^="shopName"]').remove(); // Remove Shop Title

  svg.selectAll(".shopIconTitle".concat(stockIndex)).remove(); // Add shop icon

  svg.selectAll(".shopIcon".concat(stockIndex)).data([dataset.stock.slice(-1)[0]]).join("image").attr("class", "shopIcon".concat(stockIndex)).attr("xlink:href", dataset.icon).attr("url", dataset.url).attr("height", "15").attr("width", "15").attr("x", xScale(dataset.stock.length) + 35).attr("y", dimensions.height - 108 + 17 * stockIndex).append("title").attr("class", "shopIconTitle".concat(stockIndex)).text("".concat(Facade.siteDisplayName(dataset.name)));
};
var generateStockDownload = function generateStockDownload(svg, dataset, stockIndex, dimensions, xScale, handleStockWheel, Facade) {
  // Add lines from graph to righ info bubbles
  svg.selectAll(".stockLine".concat(stockIndex)).data(dataset.stock.slice(0, -1)).join("path").attr("class", "stockLine".concat(stockIndex)).attr("d", function (value, index) {
    return "M".concat(xScale(index + 1), ",").concat(dimensions.height - 100 + 17 * stockIndex, ",l").concat(xScale(index + 2) - xScale(index + 1), ",0");
  }).attr("fill", "none").attr("stroke", function (value) {
    if (value === "en stock") return "green";
    if (value === "sup. 48h") return "red";
    if (value === "rupture") return "black";
    return "grey";
  }).attr("stroke-width", 5).on("wheel", function (e) {
    handleStockWheel(e);
  }, {
    passive: true
  }); // Add stock icon

  svg.selectAll(".stockIcon".concat(stockIndex)).data([dataset.stock.slice(-1)[0]]).join("image").attr("class", function (value) {
    return "stockIcon".concat(stockIndex);
  }).attr("style", function (value) {
    return "filter: ".concat(getFilterFromStock(value));
  }).attr("xlink:href", stockIcon).attr("height", "15").attr("width", "15").attr("x", xScale(dataset.stock.length) + 10).attr("y", dimensions.height - 108 + 17 * stockIndex); // Remove Shop Icon

  svg.selectAll('[class^="shopIcon"]').remove(); // Add shop name

  svg.selectAll(".shopName".concat(stockIndex)).data([null]).join("text").attr("class", "shopName".concat(stockIndex)).attr("x", xScale(dataset.stock.length) + 35).attr("y", dimensions.height - 97 + 17 * stockIndex).text(Facade.siteDisplayName(dataset.name));
};
var generateHoverData = function generateHoverData(svg, hoverData, hoverDate, clientMousePosition, dimensions, currency, Facade) {
  // Exclude values null, -2 and 0
  var sortedData = [];
  hoverData.forEach(function (value) {
    ![null, 0, -2].includes(value.data) && value.display && sortedData.push(value);
  }); // Sort values

  sortedData = sortArrayOnData(sortedData); // Compute bubble X and Y Position

  var bubbleX = clientMousePosition.x + 30;
  var bubbleY = clientMousePosition.y + 35 * (sortedData.length - 1) > dimensions.height ? clientMousePosition.y - 35 * (sortedData.length - 1) : clientMousePosition.y;
  var bubbleSpacing = 35; // Compute bubble width depending on biggest value

  var bubbleWidth = sortedData.length > 0 ? 40 + 5 * String(sortedData[0].data).length : 60; // Generate bubble with date

  svg.selectAll(".bubbleDate").data([null]).join("path").attr("class", "bubbleDate").attr("d", function () {
    return Shape$1.createSvgIcon(bubbleX, bubbleY, bubble(bubbleWidth), 1.7);
  }).attr("fill", "white").attr("stroke", "black").attr("stroke-width", 4);
  svg.selectAll(".bubbleDateText").data([null]).join("text").attr("class", "bubbleDateText").attr("x", bubbleX + 10).attr("y", bubbleY + 5).style("font-weight", "700").style("font-size", "13px").text("Date : ".concat(getFormatedDate(hoverDate, true))); // Generate bubbles than will contain prices

  svg.selectAll(".bubble").data(sortedData).join("path").attr("class", "bubble").attr("d", function (value, index) {
    return Shape$1.createSvgIcon(bubbleX, bubbleY + bubbleSpacing * (index + 1), bubble(bubbleWidth), 1.7);
  }).attr("fill", "white").attr("stroke", function (value) {
    return value.color;
  }).attr("stroke-width", 4); // Add shape to bubble

  svg.selectAll(".hoverToolTipShape").data(sortedData).join("path").attr("class", "hoverToolTipShape").attr("d", function (value, index) {
    return Shape$1.createSvgIcon(bubbleX, bubbleY + (index + 1) * bubbleSpacing, value.shape, 1.4);
  }).attr("fill-rule", "evenodd").attr("fill", function (value) {
    return value.color;
  }); // Add icons to bubble

  svg.selectAll(".hoverToolTipIcon").data(sortedData).join("image").attr("class", "hoverToolTipIcon").attr("xlink:href", function (value) {
    return value.icon;
  }).attr("x", bubbleX + 10).attr("y", function (value, index) {
    return bubbleY + bubbleSpacing * (index + 1) - 7.5;
  }).attr("height", "15").attr("width", "15"); // Add Price

  svg.selectAll(".hoverToolTipPrice").data(sortedData).join("text").attr("class", "hoverToolTipPrice").attr("x", bubbleX + 30).attr("y", function (value, index) {
    return bubbleY + bubbleSpacing * (index + 1) + 5;
  }).text(function (value) {
    return value.data !== -1 ? value.data !== -101 ? "".concat(Facade.showDecimal(value.data, 2)).concat(currency) : "Pending" : "Non vendu";
  }); // Ad stock icon

  svg.selectAll(".hoverToolTipStock").data(sortedData).join("image").attr("class", function (value) {
    return "hoverToolTipStock";
  }).attr("style", function (value) {
    return "filter: ".concat(value.data > 0 ? getFilterFromStock(value.stock) : 'brightness(0%) invert(100%)');
  }).attr("xlink:href", stockIcon).attr("x", bubbleX + bubbleWidth * 2 - 15).attr("y", function (value, index) {
    return bubbleY + bubbleSpacing * (index + 1) - 7.5;
  }).attr("height", "15").attr("width", "15");
};
var cleanHoverData = function cleanHoverData(svg) {
  svg.selectAll(".bubble, .bubbleDate, .bubbleDateText, .hoverToolTipShape, .hoverToolTipIcon, .hoverToolTipPrice, .hoverToolTipStock").remove();
};

var getFilterFromStock = function getFilterFromStock(stock) {

  switch (stock) {
    case "en stock":
      return "invert(72%) sepia(51%) saturate(394%) hue-rotate(65deg) brightness(91%) contrast(91%)";

    case "sup. 48h":
      return "invert(30%) saturate(400%) hue-rotate(515deg) brightness(100%) contrast(100%)";

    case "rupture":
      return "brightness(0%)";

    default:
      return "invert(0%) saturate(0%) hue-rotate(0) brightness(0%) contrast(0%)";
  }
};

var getInfFloorNum = function getInfFloorNum(value) {
  var tempValue = value * 0.1;
  tempValue = Math.trunc(tempValue);
  tempValue *= 10;
  return tempValue;
};
var getSupFloorNum = function getSupFloorNum(value) {
  var tempValue = value * 0.1;
  tempValue = Math.trunc(tempValue);
  tempValue += 1;
  tempValue *= 10;
  return tempValue;
};
var addDays = function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};
var getTickNumber = function getTickNumber(pointNumber, width) {
  var ratio = width / pointNumber;
  var tickNumber = pointNumber;
  if (ratio < 40) tickNumber = pointNumber / 4;
  if (ratio < 30) tickNumber = pointNumber / 8;
  if (ratio < 7) tickNumber = pointNumber / 16;
  return Math.floor(tickNumber);
};

Graph$1.propTypes = {
  data: PropTypes.array.isRequired,
  date: PropTypes.object.isRequired,
  currency: PropTypes.object,
  downloadMode: PropTypes.bool,
  siteDisplayName: PropTypes.func,
  showDecimal: PropTypes.func
};

function Graph$1(props) {
  var downloadMode = props.downloadMode,
      siteDisplayName = props.siteDisplayName,
      showDecimal = props.showDecimal; // Stock index is used to determine which stock line to show in first position

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      stockIndex = _useState2[0],
      setStockIndex = _useState2[1]; // Contains user mouse position {x: Number, y: Number}


  var _useState3 = useState({
    x: Number.MAX_VALUE,
    y: Number.MIN_VALUE
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      clientMousePosition = _useState4[0],
      setClientMousePosition = _useState4[1]; // hover Index used to grow points converned by hover


  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      hoverIndex = _useState6[0],
      setHoverIndex = _useState6[1];

  var Facade = {
    siteDisplayName: siteDisplayName,
    showDecimal: showDecimal
  };
  /** 
   * Data is an object used to generate graph
   * It should have this structure :
   * Array<{
   *   "data": Array<Number>, // All values
   *   "stock": Array<String>, // All stocks
   *   "shape": Shape, //Object used to create shape svg
   *   "icon": String, // Site icon url
   *   "name": String, // Site Name
   *   "url": String, // Site url
   *   "site_id": String, // Site Id
   *   "color": String, // Hexa color code
   *   "display": boolean // true if line should be displayed
   * }>
  */

  var _useState7 = useState(props.data),
      _useState8 = _slicedToArray(_useState7, 2),
      data = _useState8[0],
      setData = _useState8[1]; // data max length found


  var maxLength = Math.max.apply(Math, _toConsumableArray(data.map(function (value) {
    return value.data.length;
  }))); // Min value found in data

  var minValue = getInfFloorNum(Math.min.apply(Math, _toConsumableArray(data.map(function (value) {
    return value.data;
  }).flat().filter(function (value) {
    return value !== null && value > 0;
  })))); // Max value found in data

  var maxValue = getSupFloorNum(Math.max.apply(Math, _toConsumableArray(data.map(function (value) {
    return value.data;
  }).flat().filter(function (value) {
    return value !== null;
  }))));
  /**
   * Data to show hover mouse when user hover a point
   * hoverData should have this structure :
   * Array<{
   *   "data": Number, // Hovered data value
   *   "stock": String, // Hovered data stock
   *   "shape": Shape, //Object used to create shape svg
   *   "icon": String, // Site icon url
   *   "name": String, // Site Name
   *   "color": String, // Hexa color code
   *   "display": boolean // true if line should be displayed
   * }>
  */

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      hoverData = _useState10[0],
      setHoverData = _useState10[1]; // starting date


  var date = new Date(props.date.setHours(0, 0, 0, 0)); // Scg and svgContainer References

  var svgRef = useRef();
  var svgContainerRef = useRef(); // Svg dimensions

  var dimensions = useResizeObserver(svgContainerRef); // Scales

  var _useState11 = useState(),
      _useState12 = _slicedToArray(_useState11, 2),
      xScaleState = _useState12[0],
      setXScale = _useState12[1];

  var _useState13 = useState(),
      _useState14 = _slicedToArray(_useState13, 2),
      xScaleTimeState = _useState14[0],
      setXScaleTime = _useState14[1];

  var _useState15 = useState(),
      _useState16 = _slicedToArray(_useState15, 2),
      yScaleState = _useState16[0],
      setYScale = _useState16[1]; // All variable used to determine if an svg element should be regenerated


  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      generatedLine = _useState18[0],
      setGeneratedLine = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      generatedShapes = _useState20[0],
      setGeneratedShapes = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      generatedRightPanel = _useState22[0],
      setGeneratedRightPanel = _useState22[1];

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      generatedAxis = _useState24[0],
      setGeneratedAxis = _useState24[1];

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      generatedHoverAxis = _useState26[0],
      setGeneratedHoverAxis = _useState26[1];

  var _useState27 = useState(false),
      _useState28 = _slicedToArray(_useState27, 2),
      generatedStock = _useState28[0],
      setGeneratedStock = _useState28[1]; // Graph margin


  var margin = {
    top: 50,
    right: 200,
    bottom: 50,
    left: 70
  }; // Called when user want to scroll in stock

  var handleStockWheel = function handleStockWheel(event) {
    // stockIndex should be >= 0 and <= data.length
    event.deltaY < 0 && stockIndex - 1 >= 0 && setStockIndex(stockIndex - 1); // Wheel down ↓

    event.deltaY > 0 && stockIndex + 5 < data.length && setStockIndex(stockIndex + 1); // Wheel Up ↑

    setGeneratedStock(false);
  }; // Called when used hover a point/line


  var handleHoverPoint = function handleHoverPoint(index) {
    setHoverIndex(index);
    setHoverData(data.map(function (value) {
      return {
        data: value.data[index],
        icon: value.icon,
        name: value.name,
        stock: value.stock[index],
        color: value.color,
        shape: value.shape,
        display: value.display
      };
    }));
    setGeneratedHoverAxis(false);
  }; // Called when user was hovering point and leave it


  var handleLeavePoint = function handleLeavePoint() {
    setHoverData([]);
    setHoverIndex(null);
  }; // Called when user click on a bubble in right panel


  var handleBubbleClick = function handleBubbleClick(item) {
    var tempData = data.map(function (value) {
      return {
        color: value.color,
        data: value.data,
        display: item.name === value.name ? !value.display : value.display,
        icon: value.icon,
        name: value.name,
        shape: value.shape,
        stock: value.stock
      };
    });
    setData(tempData);
    setGeneratedLine(false);
    setGeneratedShapes(false);
    setGeneratedRightPanel(false);
  }; // Called when variables changes


  useEffect(function () {
    // If no changes has to be made, return
    if (!dimensions || generatedLine && generatedShapes && generatedRightPanel && generatedAxis && generatedHoverAxis && generatedStock && (hoverIndex === undefined || hoverData.length === 0)) return; // Select svg node

    var svg = d3.select(svgRef.current);
    var svgGraph = svg.select('.graph');
    var svgRight = svg.select('.rightData');
    var svgStock = svg.select('.stock');
    var svgHover = svg.select('.hoverData'); //xScale

    var xScale = xScaleState ? xScaleState : d3.scaleLinear().domain([0, maxLength]).range([margin.left, dimensions.width - margin.right]);
    !xScaleState && setXScale(xScale); // xScaleTime

    var xScaleTime = xScaleTimeState ? xScaleTimeState : d3.scaleTime().domain([addDays(date, 0), addDays(date, maxLength - 1)]).range([xScale(1), dimensions.width - margin.right]);
    !xScaleTimeState && setXScaleTime(xScaleTime); // yScale

    var yScale = yScaleState ? yScaleState : d3.scaleLinear().domain([minValue >= 0 ? minValue : 0, maxValue]).range([dimensions.height - margin.top - 100, 0 + margin.bottom]);
    !yScale && setYScale(yScale); // Refresh mouse position state when mouse move

    clientMousePosition.x === Number.MAX_VALUE && clientMousePosition.y === Number.MIN_VALUE && svg.on('mousemove', function (e) {
      setClientMousePosition({
        x: d3.pointer(e)[0],
        y: d3.pointer(e)[1]
      });
    }); // Generate stocks

    var generateStockBackground$1;
    var generateStock$1;
    var generateRightPanel$1;

    if (!downloadMode) {
      generateStock$1 = generateStock;
      generateStockBackground$1 = generateStockBackground;
      generateRightPanel$1 = generateRightPanel;
    } else {
      generateStock$1 = generateStockDownload;
      generateStockBackground$1 = generateStockBackgroundDownload;
      generateRightPanel$1 = generateRightPanelDownload;
    }

    if (!generatedStock) {
      generateStockBackground$1(svgStock, dimensions, xScale, maxLength, handleStockWheel); // recreate data array with only last value in data field

      var lastValue = data.map(function (value) {
        return {
          data: value.data.slice(-1)[0],
          icon: value.icon,
          url: value.url,
          stock: value.stock,
          name: value.name
        };
      }); // Sort array on last value

      lastValue = sortArrayOnData(lastValue);
      lastValue.slice(stockIndex, stockIndex + 5).forEach(function (dataset, shapeIndex) {
        generateStock$1(svgStock, dataset, shapeIndex, dimensions, xScale, handleStockWheel, Facade);
      });
      setGeneratedStock(true);
    } // Generate Axis


    if (!generatedAxis) {
      var tickNumber = dimensions ? getTickNumber(maxLength, dimensions.width) : maxLength; // Generate Y lines

      generateYAxis(svg, yScale, dimensions, margin); // Generate X lines

      generateXAxis(svg, dimensions, xScaleTime, tickNumber);
      setGeneratedAxis(true); // Generate Y lines Label on left side

      generateYAxisLabel(svg, dimensions, -dimensions.height / 2 + margin.top, xScale(0) - 40, props.currency.symbol);
    } // Generate Line hover Axis if mouse hover line or point


    if (!generatedHoverAxis) {
      // Axis Hover
      var xAxisHover = d3.axisBottom(xScaleTime).ticks(maxLength).tickSize(-dimensions.height + 20).tickFormat(formatXTick); // Generate X lines only displayed when user hover them

      generateXAxisHover(svg, xAxisHover, dimensions, handleHoverPoint, handleLeavePoint, hoverIndex);
      setGeneratedHoverAxis(true);
    } // Generate Lines with points


    (!generatedShapes || !generatedLine) && data.forEach(function (dataset, shapeIndex) {
      var datasetCount = dataset.data.filter(function (oneData) {
        return oneData !== null;
      }).length;

      if (datasetCount > 0) {
        if (!generatedLine) {
          generateLine$1(svgGraph, dataset, shapeIndex, xScale, yScale, dimensions.width * 0.003);
          setGeneratedLine(true);
        }

        if (!generatedShapes) {
          generateShapes(svgGraph, dataset, shapeIndex, xScale, yScale, hoverIndex, handleHoverPoint, handleLeavePoint, dimensions.width * 0.0009, minValue);
          setGeneratedShapes(true);
        }
      }
    }); // Generate bubbles on right side

    if (!generatedRightPanel) {
      generateRightPanel$1(svgRight, data, xScale, yScale, Math.max.apply(Math, _toConsumableArray(data.map(function (value) {
        return value.data.length;
      }))), handleBubbleClick, props.currency.symbol, dimensions, Facade, minValue);
      setGeneratedRightPanel(true);
    } // Generate bubble hover mouse


    hoverIndex !== undefined && hoverData.length > 0 && generateHoverData(svgHover, hoverData, addDays(date, hoverIndex), clientMousePosition, dimensions, props.currency.symbol, Facade);
    (hoverIndex === undefined || hoverData.length === 0) && cleanHoverData(svgHover);
  }, [data, dimensions, stockIndex, hoverData, clientMousePosition, generatedLine]); // Update Line when data or dimensions changes

  useEffect(function () {
    setGeneratedLine(false);
    setGeneratedRightPanel(false);
    setGeneratedAxis(false);
    setGeneratedStock(false);
  }, [data, dimensions]); // Update Shapes when data, hoverData or dimensions changes

  useEffect(function () {
    setGeneratedShapes(false);
    setGeneratedHoverAxis(false);
  }, [data, dimensions, hoverData]); // Update Shapes when data, hoverData or dimensions changes

  useEffect(function () {
    setGeneratedStock(false);
  }, [stockIndex]);
  return /*#__PURE__*/React.createElement("div", {
    ref: svgContainerRef,
    style: {
      width: '100%',
      height: '94%'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    ref: svgRef,
    style: {
      width: '100%',
      height: '100%',
      overflow: 'overlay'
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "stock"
  }), /*#__PURE__*/React.createElement("g", {
    className: "rightData"
  }), /*#__PURE__*/React.createElement("g", {
    className: "x-axis"
  }), /*#__PURE__*/React.createElement("g", {
    className: "y-axis"
  }), /*#__PURE__*/React.createElement("g", {
    className: "x-axis-hover"
  }), /*#__PURE__*/React.createElement("g", {
    className: "graph"
  }), /*#__PURE__*/React.createElement("g", {
    className: "hoverData"
  })));
}

var Shape = /*#__PURE__*/function () {
  function Shape(coord, centerX, centerY) {
    _classCallCheck(this, Shape);

    this.coord = coord;
    this.centerX = centerX;
    this.centerY = centerY;
  }

  _createClass(Shape, [{
    key: "createSvgIcon",
    value: function createSvgIcon(x, y, scale) {
      var result = "m ".concat(x - this.centerX * scale, " ").concat(y - this.centerY * scale, " ");

      for (var i = 0; i < this.coord.length; i++) {
        if (this.coord[i].type === 'line') result += "l ".concat(this.coord[i].x * scale, " ").concat(this.coord[i].y * scale);else if (this.coord[i].type === 'arc') {
          result += "a ".concat(this.coord[i].rx, " ").concat(this.coord[i].ry, " ").concat(this.coord[i].xAxisRotation, " ").concat(this.coord[i].largeArc, " ").concat(this.coord[i].otherSide, " ").concat(this.coord[i].x * scale, " ").concat(this.coord[i].y * scale);
        }
        if (i < this.coord.length) result += ' ';
      }

      return result;
    }
  }]);

  return Shape;
}();

var upsideDownTriangle = new Shape([// a 10 10 0 0 1 5 -17.5
{
  type: 'arc',
  rx: 10,
  ry: 10,
  xAxisRotation: 0,
  largeArc: 0,
  otherSide: 1,
  x: 5,
  y: -17.5
}, // l 70 0
{
  type: 'line',
  x: 70,
  y: 0
}, // a 10 10 0 0 1 5 17.5
{
  type: 'arc',
  rx: 10,
  ry: 10,
  xAxisRotation: 0,
  largeArc: 0,
  otherSide: 1,
  x: 5,
  y: 17.5
}, // l -30 25
{
  type: 'line',
  x: -30,
  y: 25
}, // a 17 17 0 0 1 -20 0
{
  type: 'arc',
  rx: 17,
  ry: 17,
  xAxisRotation: 0,
  largeArc: 0,
  otherSide: 1,
  x: -20,
  y: 0
}, // l -30 -25
{
  type: 'line',
  x: -30,
  y: -25
}], 40, 0);

/**
  * Add to an svg a band
  *
  * @param svg Svg to modify
  * @param className Created svg item class name
  * @param x X Position in pixel
  * @param y Y Position in pixel
  * @param width Band width
  * @param height Band height
  * @param color Color used by band
  * @returns void
  */

var generateBand = function generateBand(svg, className, x, y, width, height, color) {
  svg.selectAll(".".concat(className)).data([null]).join('rect').attr('class', className).attr('x', x).attr('y', y).attr('rx', 3).attr('ry', 3).attr('width', width).attr('height', height).attr('fill', color);
};
/**
  * Add a big text to svg
  *
  * @param svg Svg to modify
  * @param x X Position in pixel
  * @param y Y Position in pixel
  * @param textAchor text anchor used by svg element
  * @param mobile Mobile mode ?
  * @param value Text to show
  * @returns void
  */

var generateBigPriceText = function generateBigPriceText(svg, x, y) {
  var textAchor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'middle';
  var mobile = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var value = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  svg.selectAll('.bigPriceText').data([null]).join('text').attr('class', 'bigPriceText').attr('x', x).attr('y', y).attr('font-family', 'Roboto, sans-serif').attr('font-size', mobile ? '30px' : '50px').attr('font-weight', 'bold').attr('fill', '#1A9FB7').attr('text-anchor', textAchor).style('filter', 'drop-shadow( -3px 3px 3px rgba(0, 0, 0, .3))').text(function () {
    return value;
  });
};
/**
  * Add a text to svg
  *
  * @param svg Svg to modify
  * @param className Created svg item class name
  * @param x X Position in pixel
  * @param y Y Position in pixel
  * @param text Text to show
  * @param anchor Text anchor used by svg element
  * @returns void
  */

var generateTextValue = function generateTextValue(svg, className, x, y, text) {
  var anchor = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'middle';
  var bold = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  svg.selectAll(".".concat(className)).data([null]).join('text').attr('class', className).attr('x', x).attr('y', y).attr('text-anchor', anchor).attr('font-family', 'Roboto, sans-serif').attr('font-size', '15px').attr('font-weight', bold ? '1000' : '500').attr('fill', '#1A9FB7').text(text);
};
/**
  * Add a line to svg
  *
  * @param svg Svg to modify
  * @param className Created svg item class name
  * @param x X Position in pixel
  * @param y Y Position in pixel
  * @param width Line width
  * @param height Line stroke
  * @param color Color used by line
  * @returns void
  */

var generateLine = function generateLine(svg, className, x, y, width, height, color) {
  svg.selectAll(".".concat(className)).data([null]).join('path').attr('class', className).attr('d', "m ".concat(x, " ").concat(y, " l 0 ").concat(height)).attr('stroke', color).attr('stroke-width', width).style('filter', 'drop-shadow( -3px 3px 3px rgba(0, 0, 0, .3))');
};
/**
  * Add an upsideDownTriangle to svg
  *
  * @param svg Svg to modify
  * @param x X Position in pixel
  * @param y Y Position in pixel
  * @returns void
  */

var generateUpsideDownTriangle = function generateUpsideDownTriangle(svg, x, y, index) {
  svg.selectAll(".avgTriangle".concat(index)).data([null]).join('path').attr('class', "avgTriangle".concat(index)).attr('d', upsideDownTriangle.createSvgIcon(x, y, 0.2)).attr('fill', '#126D7D').style('filter', 'drop-shadow( -3px 3px 3px rgba(0, 0, 0, .3))');
};
var getTextAnchor = function getTextAnchor(minPrice, maxPrice, price) {
  var priceDiff = maxPrice - minPrice;
  if (price < minPrice + priceDiff / 3) return 'start';else if (price > maxPrice - priceDiff / 3) return 'end';
  return 'middle';
};

function Graph(props) {
  Graph.propTypes = {
    data: PropTypes.object.isRequired,
    supplierMode: PropTypes.bool,
    currency: PropTypes.string,
    translate: PropTypes.func,
    showDecimal: PropTypes.func
  };

  var _useState = useState(props.data),
      _useState2 = _slicedToArray(_useState, 1),
      data = _useState2[0];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      mobile = _useState4[0],
      setMobile = _useState4[1];

  var supplierMode = props.supplierMode ? props.supplierMode : false;
  var currency = props.currency,
      showDecimal = props.showDecimal,
      translate = props.translate;
  var svgRef = useRef();
  var svgContainerRef = useRef();
  var dimensions = useResizeObserver(svgContainerRef);
  var bigPriceY = supplierMode ? 3 : 8;
  var bandY = bigPriceY + (supplierMode ? 12 : 10);
  var bandHeight = 7;
  var aboveTextY = bigPriceY + (supplierMode ? 7 : 6.5);
  useEffect(function () {
    if (!dimensions) return;
    dimensions.width < 340 ? setMobile(true) : setMobile(false); // Graph margin

    var margin = {
      top: 0,
      right: mobile ? 10 : 50,
      bottom: 0,
      left: mobile ? 10 : 50
    }; // Select svg node

    var svgGraph = d3.select('.graph'); // Check if all value are equal

    var allValueEqual = data.minPrice === data.maxPrice;
    var xScale = props.supplierMode ? d3.scaleLinear().domain([allValueEqual ? 0 : Math.min(data.minPrice, data.alertLowPrice), allValueEqual ? 10 : Math.max(data.maxPrice, data.rrp)]).range([0 + margin.left, dimensions.width - margin.right]) : d3.scaleLinear().domain([allValueEqual ? 0 : data.minPrice, allValueEqual ? 10 : data.maxPrice]).range([0 + margin.left, dimensions.width - margin.right]);
    var yScale = d3.scaleLinear().domain([0, 30]).range([0, dimensions.height]);

    if (allValueEqual) {
      /**
       * All value are equal
       */
      // Add left Line
      generateBand(svgGraph, 'lineLeft', xScale(0), yScale(bandY), xScale(5), yScale(bandHeight), 'url(#MyGradient2)');
      generateBand(svgGraph, 'lineRight', xScale(5), yScale(bandY), xScale(10), yScale(bandHeight), 'url(#MyGradient3)'); // Add Price Text

      if (data.yourPrice) {
        var bigPriceTextAnchor = getTextAnchor(data.minPrice, data.maxPrice, data.yourPrice);
        generateBigPriceText(svgGraph, xScale(5), yScale(bigPriceY), bigPriceTextAnchor, mobile, "".concat(showDecimal(data.yourPrice, 2)).concat(currency));
      } // Add Avg text


      var priceDiff = data.maxPrice - data.minPrice;
      var avgPriceTextAnchor;
      if (data.yourAvgPrice < data.minPrice + priceDiff / 3) avgPriceTextAnchor = 'start';else if (data.yourAvgPrice > data.maxPrice - priceDiff / 3) avgPriceTextAnchor = 'end';else avgPriceTextAnchor = 'middle';
      generateTextValue(svgGraph, 'avgText1', xScale(5), yScale(aboveTextY), translate.i18n('PRODUCT_PAGE_PRICE_SECTION_YOUR_AVERAGE_PRICE'), avgPriceTextAnchor, 'middle', true);
      generateTextValue(svgGraph, 'avgText2', xScale(5), yScale(aboveTextY + 2.5), "".concat(showDecimal(data.yourAvgPrice, 2)).concat(currency), avgPriceTextAnchor); // Add Avg line

      generateLine(svgGraph, 'avgLine', xScale(5), yScale(bandY), 3, yScale(bandHeight), '#FFFFFF'); // Add Avg upsideDown triangle

      generateUpsideDownTriangle(svgGraph, xScale(5), yScale(bandY)); // Add line underneath big price

      generateLine(svgGraph, 'lineUnderPrice', xScale(5), yScale(bigPriceY + 2), 2, yScale(2), '#ABABAB'); // Add MinAll Text

      generateTextValue(svgGraph, 'minAllTextallValueEqual1', xScale(0), yScale(bandY + bandHeight + 2.5), translate.i18n('PRODUCT_PAGE_PRICE_SECTION_PRODUCT_MIN_PRICE'), 'start', true);
      generateTextValue(svgGraph, 'minAllTextallValueEqual2', xScale(0), yScale(bandY + bandHeight + 5), "".concat(showDecimal(data.minPrice, 2)).concat(currency), 'start', false); // Add AVG ALL Text

      generateTextValue(svgGraph, 'avgAllTextallValueEqual1', xScale(5), yScale(bandY + bandHeight + 2.5), translate.i18n('PRODUCT_PAGE_PRICE_SECTION_PRODUCT_AVG_PRICE'), 'middle', true);
      generateTextValue(svgGraph, 'avgAllTextallValueEqual2', xScale(5), yScale(bandY + bandHeight + 5), "".concat(showDecimal(data.avgPrice, 2)).concat(currency), 'middle', false); // Add Max All Text

      generateTextValue(svgGraph, 'maxAllTextallValueEqual1', xScale(10), yScale(bandY + bandHeight + 2.5), translate.i18n('PRODUCT_PAGE_PRICE_SECTION_PRODUCT_MAX_PRICE'), 'end', true);
      generateTextValue(svgGraph, 'maxAllTextallValueEqual2', xScale(10), yScale(bandY + bandHeight + 5), "".concat(showDecimal(data.maxPrice, 2)).concat(currency), 'end', false);
    } else if (supplierMode) {
      /**
       * Supplier Mode
       */
      if (data.rrp <= data.maxPrice && data.rrp >= data.minPrice) {
        generateBand(svgGraph, 'lineLeft', xScale(data.minPrice), yScale(bandY), xScale(data.alertLowPrice) - xScale(data.minPrice), yScale(bandHeight), 'url(#MyGradient2)');
        generateBand(svgGraph, 'lineMiddle', xScale(data.alertLowPrice), yScale(bandY), xScale(data.rrp) - xScale(data.alertLowPrice), yScale(bandHeight), 'url(#MyGradient1)');
        generateBand(svgGraph, 'lineRight', xScale(data.rrp), yScale(bandY), xScale(data.maxPrice) - xScale(data.rrp), yScale(bandHeight), 'url(#MyGradient3)'); // Add RRP Text

        generateTextValue(svgGraph, 'RRPText1', xScale(data.rrp), yScale(bigPriceY), 'RRP', 'middle', true);
        generateTextValue(svgGraph, 'RRPText2', xScale(data.rrp), yScale(bigPriceY + 2.5), "".concat(showDecimal(data.rrp, 2)).concat(currency)); // Add Avg price

        generateTextValue(svgGraph, 'AlertText1', xScale(data.alertLowPrice), yScale(aboveTextY), translate.i18n('PRODUCT_PAGE_PRICE_SECTION_PRODUCT_ALERT_PRICE'), 'middle', true);
        generateTextValue(svgGraph, 'AlertText2', xScale(data.alertLowPrice), yScale(aboveTextY + 2.5), "".concat(showDecimal(data.alertLowPrice, 2)).concat(currency)); // Add Avg line

        generateLine(svgGraph, 'avgLine', xScale(data.rrp), yScale(bandY), 3, yScale(bandHeight), '#FFFFFF'); // Add Avg upsideDown triangle

        generateUpsideDownTriangle(svgGraph, xScale(data.rrp), yScale(bandY), 1);
        generateUpsideDownTriangle(svgGraph, xScale(data.alertLowPrice), yScale(bandY), 2); // Add avg All text

        generateTextValue(svgGraph, 'avgAllText1', xScale(data.avgPrice), yScale(bandY + bandHeight + 2.5), translate.i18n('PRODUCT_PAGE_PRICE_SECTION_PRODUCT_AVG_PRICE'), 'middle', true);
        generateTextValue(svgGraph, 'avgAllText2', xScale(data.avgPrice), yScale(bandY + bandHeight + 5), "".concat(showDecimal(data.avgPrice, 2)).concat(currency));
      } else {
        generateBand(svgGraph, 'lineLeft', xScale(Math.min(data.minPrice, data.rrp)), yScale(bandY), xScale(data.alertLowPrice) - xScale(Math.min(data.minPrice, data.rrp)), yScale(bandHeight), 'url(#MyGradient2)');
        generateBand(svgGraph, 'lineMiddle', xScale(data.alertLowPrice), yScale(bandY), xScale(data.rrp) - xScale(data.alertLowPrice), yScale(bandHeight), 'url(#MyGradient1)');
        generateBand(svgGraph, 'lineRight', xScale(data.rrp), yScale(bandY), xScale(data.maxPrice) - xScale(data.rrp), yScale(bandHeight), 'url(#MyGradient3)'); // Add RRP Text

        generateTextValue(svgGraph, 'RRPText1', xScale(data.rrp), yScale(bigPriceY), 'RRP', 'middle', true);
        generateTextValue(svgGraph, 'RRPText2', xScale(data.rrp), yScale(bigPriceY + 2.5), "".concat(showDecimal(data.rrp, 2)).concat(currency)); // Add Avg price

        generateTextValue(svgGraph, 'AlertText1', xScale(data.alertLowPrice), yScale(aboveTextY), translate.i18n('PRODUCT_PAGE_PRICE_SECTION_PRODUCT_ALERT_PRICE'), 'middle', true);
        generateTextValue(svgGraph, 'AlertText2', xScale(data.alertLowPrice), yScale(aboveTextY + 2.5), "".concat(showDecimal(data.alertLowPrice, 2)).concat(currency)); // Add Avg line

        generateLine(svgGraph, 'avgLine', xScale(data.rrp), yScale(bandY), 3, yScale(bandHeight), '#FFFFFF'); // Add Avg upsideDown triangle

        generateUpsideDownTriangle(svgGraph, xScale(data.rrp), yScale(bandY), 1);
        generateUpsideDownTriangle(svgGraph, xScale(data.alertLowPrice), yScale(bandY), 2); // Add avg All text

        generateTextValue(svgGraph, 'avgAllText1', xScale(data.avgPrice), yScale(bandY + bandHeight + 2.5), translate.i18n('PRODUCT_PAGE_PRICE_SECTION_PRODUCT_AVG_PRICE'), 'middle', true);
        generateTextValue(svgGraph, 'avgAllText2', xScale(data.avgPrice), yScale(bandY + bandHeight + 5), "".concat(showDecimal(data.avgPrice, 2)).concat(currency));
      }
    } else {
      /**
       * Retailer Mode
       */
      // Add left Line
      generateBand(svgGraph, 'lineLeft', xScale(data.minPrice), yScale(bandY), xScale(data.avgPrice), yScale(bandHeight), 'url(#MyGradient2)');
      generateBand(svgGraph, 'lineRight', xScale(data.avgPrice), yScale(bandY), xScale(data.maxPrice) - xScale(data.avgPrice), yScale(bandHeight), 'url(#MyGradient1)'); // Add Price Text

      if (data.yourPrice) {
        var _bigPriceTextAnchor = getTextAnchor(data.minPrice, data.maxPrice, data.yourPrice);

        generateBigPriceText(svgGraph, xScale(data.yourPrice), yScale(bigPriceY), _bigPriceTextAnchor, mobile, "".concat(showDecimal(data.yourPrice, 2)).concat(currency));
      } // Add Avg text


      var _priceDiff = data.maxPrice - data.minPrice;

      var _avgPriceTextAnchor;

      if (data.yourAvgPrice < data.minPrice + _priceDiff / 3) _avgPriceTextAnchor = 'start';else if (data.yourAvgPrice > data.maxPrice - _priceDiff / 3) _avgPriceTextAnchor = 'end';else _avgPriceTextAnchor = 'middle';
      generateTextValue(svgGraph, 'avgText1', xScale(data.yourAvgPrice), yScale(aboveTextY), translate.i18n('PRODUCT_PAGE_PRICE_SECTION_YOUR_AVERAGE_PRICE'), _avgPriceTextAnchor, 'middle', true);
      generateTextValue(svgGraph, 'avgText2', xScale(data.yourAvgPrice), yScale(aboveTextY + 2.5), "".concat(showDecimal(data.yourAvgPrice, 2)).concat(currency), _avgPriceTextAnchor); // Add Avg line

      generateLine(svgGraph, 'avgLine', xScale(data.avgPrice), yScale(bandY), 3, yScale(bandHeight), '#FFFFFF'); // Add Avg upsideDown triangle

      generateUpsideDownTriangle(svgGraph, xScale(data.avgPrice), yScale(bandY)); // Add line underneath big price

      generateLine(svgGraph, 'lineUnderPrice', xScale(data.yourPrice), yScale(bigPriceY + 2), 2, yScale(2), '#ABABAB'); // Add Alert low price Line

      generateLine(svgGraph, 'alertLine', xScale(data.alertLowPrice), yScale(bandY), 3, yScale(bandHeight), '#FFFFFF');
    }
    /**
     * Both Mode
     */
    // Add MinAll Text


    generateTextValue(svgGraph, 'minAllText1', xScale(data.minPrice), yScale(bandY + bandHeight + 2.5), translate.i18n('PRODUCT_PAGE_PRICE_SECTION_MIN_PRICE'), 'start', true);
    generateTextValue(svgGraph, 'minAllText2', xScale(data.minPrice), yScale(bandY + bandHeight + 5), "".concat(showDecimal(data.minPrice, 2)).concat(currency), 'start', false); // Add AVG ALL Text

    generateTextValue(svgGraph, 'avgAllText1', xScale(data.avgPrice), yScale(bandY + bandHeight + 2.5), translate.i18n('PRODUCT_PAGE_PRICE_SECTION_PRODUCT_AVG_PRICE'), 'middle', true);
    generateTextValue(svgGraph, 'avgAllText2', xScale(data.avgPrice), yScale(bandY + bandHeight + 5), "".concat(showDecimal(data.avgPrice, 2)).concat(currency), 'middle', false); // Add Max All Text

    generateTextValue(svgGraph, 'maxAllText1', xScale(data.maxPrice), yScale(bandY + bandHeight + 2.5), translate.i18n('PRODUCT_PAGE_PRICE_SECTION_MAX_PRICE'), 'end', true);
    generateTextValue(svgGraph, 'maxAllText2', xScale(data.maxPrice), yScale(bandY + bandHeight + 5), "".concat(showDecimal(data.maxPrice, 2)).concat(currency), 'end', false);
  }, [aboveTextY, bandY, bigPriceY, currency, data, dimensions, mobile, showDecimal, supplierMode, translate]);
  return /*#__PURE__*/React.createElement("div", {
    ref: svgContainerRef,
    style: {
      width: '100%',
      height: '94%'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    ref: svgRef,
    style: {
      width: '100%',
      height: '100%',
      overflow: 'visible !important'
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "graph"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "MyGradient1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#1A9FB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#5ED3E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "MyGradient2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#0A3E47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#1890A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "MyGradient3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#1890A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#0A3E47"
  })))));
}

/**
  * Get color string from selected number
  *
  * @param value Selected number
  * @returns string
  */
var getColor = function getColor(value) {
  switch (value) {
    case 0:
      return '#5ED3E8';

    case 1:
      return '#1A9FB7';

    case 2:
      return '#0A3E47';

    default:
      return '#919191';
  }
};
/**
  * Get selected number from strutus string
  *
  * @param status Selected string
  * @returns number
  */

var getSelected = function getSelected(status) {
  switch (status) {
    case 'SOLD':
      return 0;

    case 'PENDING':
      return 0;

    case 'NV_BELL':
      return 1;

    case 'NV':
      return 2;

    default:
      return 3;
  }
};
/**
  * Get Status from selected number
  *
  * @param selected Selected number
  * @returns string || undefined
  */

var getStatus = function getStatus(selected) {
  switch (selected) {
    case 0:
      return 'SOLD';

    case 1:
      return 'NV_BELL';

    case 2:
      return 'NV';

    default:
      return undefined;
  }
};

function StatusGraph(props) {
  StatusGraph.propTypes = {
    status: PropTypes.string,
    url: PropTypes.string,
    handleStatusChange: PropTypes.func
  }; // eslint-disable-next-line no-unused-vars

  var status = props.status,
      url = props.url,
      handleStatusChange = props.handleStatusChange;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var svgRef = useRef();
  var svgContainerRef = useRef();
  var dimensions = useResizeObserver(svgContainerRef); // Graph margin

  var margin = {
    top: 10,
    right: 70,
    bottom: 10,
    left: 70
  };
  useEffect(function () {
    if (!dimensions) return;

    if ((!url || url === '') && selected === 0) {
      handleStatusChange(undefined);
    }

    setSelected(getSelected(status)); // Select svg node

    var svg = d3.select(svgRef.current);
    var svgText = svg.select('.textElement');
    var svgStatus = svg.select('.statusElement'); // xScale

    var xScale = d3.scaleLinear().domain([0, 3]).range([0 + margin.left, dimensions.width - margin.right]); // yScale

    var yScale = d3.scaleLinear().domain([0, 10]).range([0 + margin.top, dimensions.height - margin.bottom]); // Set svg style and event on mousemove

    svg.style('background-color', 'rgba(255, 255, 255, 1)'); // Add line

    svgStatus.selectAll('.statusLine').data([null]).join('path').attr('class', 'statusLine').attr('d', "m ".concat(xScale(0) + 20, " ").concat(yScale(5), " l ").concat(xScale(3) - xScale(0) - 40, " 0 ")).attr('stroke', getColor(selected)).attr('stroke-width', '3px'); // Add circles

    svgStatus.selectAll('.statusRound').data([1, 2, 3, 4]).join('circle').attr('class', 'statusRound').attr('id', function (value) {
      return "statusRound".concat(value);
    }).attr('selected', function (value, index) {
      return selected === index;
    }).attr('r', function (value, index) {
      return selected === index ? '15' : '10';
    }).attr('cx', function (value) {
      return xScale(value - 1);
    }).attr('cy', yScale(5)).attr('fill', function (value, index) {
      if (index === 0) {
        return url ? getColor(selected) : getColor(3);
      }

      return getColor(selected);
    });
    svgStatus.selectAll('.statusRound').on('mouseenter', function (e, index) {
      (url || !url && index > 1) && svgStatus.select("#".concat(e.target.id)).transition().duration(300).attr('r', '15');
    }).on('mouseleave', function (e, index) {
      (url || !url && index > 1) && svgStatus.select("#".concat(e.target.id)).transition().duration(500).attr('r', function () {
        return e.target.getAttribute('selected') === 'true' ? '15' : '10';
      });
    }).on('click', function (e, index) {
      if (index - 1 !== selected) {
        if (url) {
          var newStatus = getStatus(index - 1);
          handleStatusChange(newStatus);
        } else {
          if (index - 1 > 0) {
            var _newStatus = getStatus(index - 1);

            handleStatusChange(_newStatus);
          }
        }
      } else {
        handleStatusChange(undefined);
      }
    }); // Add text above circles

    selected <= 2 && svgText.selectAll('.statusText').data([selected]).join('text').attr('class', 'statusText').attr('style', 'font-size: 20px; width: 2px').attr('text-anchor', 'middle').attr('x', xScale(selected)).attr('y', yScale(2)).text(function (value) {
      return value === 0 ? 'Vendu' : 'Non vendu';
    }); // If select is === 3 remove text

    selected === 3 && svgText.selectAll('.statusText').remove(); // Add bell if status is NV_BELL

    selected === 1 && svgStatus.selectAll('.statusBell').data([selected]).join('path').attr('class', 'statusBell').attr('d', selected === 1 ? 'M6.99992 16.3334C7.91658 16.3334 8.66658 15.5834 8.66658 14.6667H5.33325C5.33325 15.5834 6.07492 16.3334 6.99992 16.3334ZM11.9999 11.3334V7.16671C11.9999 4.60837 10.6332 2.46671 8.24992 1.90004V1.33337C8.24992 0.641707 7.69158 0.083374 6.99992 0.083374C6.30825 0.083374 5.74992 0.641707 5.74992 1.33337V1.90004C3.35825 2.46671 1.99992 4.60004 1.99992 7.16671V11.3334L0.333252 13V13.8334H13.6666V13L11.9999 11.3334Z' : 'M 0 0').attr('fill', '#FACD19').attr('fill-opacity', '0.87').attr('transform', "translate(".concat(xScale(1) - 7, " ").concat(yScale(5) - 8, ")")).on('click', function () {
      return handleStatusChange(undefined);
    });
    selected !== 1 && svgStatus.selectAll('.statusBell').remove();
  }, [dimensions, selected, url, status, margin.left, margin.right, margin.top, margin.bottom, handleStatusChange]);
  return /*#__PURE__*/React.createElement("div", {
    ref: svgContainerRef,
    style: {
      width: '100%',
      height: '94%'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    height: "100",
    ref: svgRef,
    style: {
      width: '100%',
      height: '100%',
      overflow: 'visible !important'
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "textElement"
  }), /*#__PURE__*/React.createElement("g", {
    className: "statusElement"
  })));
}

var colors = ['#DF2020', '#4FB200', '#4064E5', '#FFB800', '#9B21C6', '#C36223', '#000000'];

export { Graph$1 as Graph, Graph as PricePositionGraph, StatusGraph, colors, shapes };
